var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCopyIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6007_9095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 6.6665H8.99992C8.07944 6.6665 7.33325 7.4127 7.33325 8.33317V14.9998C7.33325 15.9203 8.07944 16.6665 8.99992 16.6665H15.6666C16.5871 16.6665 17.3333 15.9203 17.3333 14.9998V8.33317C17.3333 7.4127 16.5871 6.6665 15.6666 6.6665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.66683V5.00016C14 4.55814 13.8244 4.13421 13.5118 3.82165C13.1993 3.50909 12.7754 3.3335 12.3333 3.3335H5.66667C5.22464 3.3335 4.80072 3.50909 4.48816 3.82165C4.17559 4.13421 4 4.55814 4 5.00016V11.6668C4 12.1089 4.17559 12.5328 4.48816 12.8453C4.80072 13.1579 5.22464 13.3335 5.66667 13.3335H7.33333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6007_9095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.666626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCopyIcon2);
export default __webpack_public_path__ + "static/media/whiteCopyIcon2.846caafa62a34287216aac1918e636be.svg";
export { ForwardRef as ReactComponent };